<template>
  <app-chip
    class="overflow-hidden !text-xs"
    :class="{
      'pr-0': hasOtherSessions,
      'bg-accent-100 text-accent-950': color === undefined,
      'bg-white text-black': color === 'light',
    }"
    size="small"
  >
    Complet

    <span
      v-if="hasOtherSessions"
      class="flex h-full items-center whitespace-nowrap px-1"
      :class="{
        'bg-accent text-white': color === undefined,
        'bg-black text-white': color === 'light',
      }"
      >+ dates</span
    >
  </app-chip>
</template>

<script lang="ts" setup>
defineProps<{
  hasOtherSessions?: boolean;
  color?: "light";
}>();
</script>
